import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

function ServerRevisionCommentModal({ commentModalState, onClose }) {
  const { openModal, params } = commentModalState;
  const { t } = useTranslation();
  return (
    <>
      <Dialog open={openModal} onClose={onClose} maxWidth={"xs"}>
        <DialogTitle className="dialog-header">
          <div>
            <div className="title">
              {t("REVISION")} {params.data.revision_id}
            </div>
          </div>
        </DialogTitle>
        <Divider></Divider>
        <DialogContent>
          <div style = {{fontSize:'13px'}}>
            <div>
              <p>
                {t("REVISION")} : {params.data.revision_id}
              </p>
            </div>
            <div>
              <p>
                {t("USER")} : {params.data.user}
              </p>
            </div>
            <div>
              <p>
                {t("DATE_")} : {params.data.date}
              </p>
            </div>
            <div>
              <p>
                {t("COMMENT")} : {params.data.comment}
              </p>
            </div>
          </div>
        </DialogContent>
        <Divider></Divider>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={onClose}>
            {t("BTN_OK")} 
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ServerRevisionCommentModal;
